import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  Button,
  Divider,
  useTheme,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

import { styles } from '../styles';

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default function ConfirmationDialog({ open, onClose, onConfirm, title, message }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark'; // Added to resolve active dark-mode state

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          ...styles.cardBase,
          maxWidth: '400px',
          p: 0,
          // FIXED: Overrides the light-only background color in dark mode
          bgcolor: isDark ? 'background.paper' : '#FFFFFF',
          border: isDark ? `1px solid ${theme.palette.divider}` : 'none',
        },
      }}
    >
      <DialogTitle
        sx={{ fontWeight: 700, fontFamily: 'inherit', pt: 2, color: 'text.primary' }}
      >
        {title || t('ticket.confirmChangeTitle')}
      </DialogTitle>
      <Divider sx={{ borderBottomWidth: '0.3px', borderColor: theme.palette.divider }} />

      <DialogContent sx={{ py: 3 }}>
        <Typography
          sx={{ fontFamily: 'inherit', fontSize: '0.9rem', color: 'text.primary' }}
        >
          {message || t('ticket.confirmChangeMessage')}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose} color="inherit" sx={{ fontWeight: 700 }}>
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            bgcolor: theme.palette.primary.main,
            fontWeight: 700,
            borderRadius: '8px',
            '&:hover': { bgcolor: theme.palette.primary.dark },
          }}
        >
          {t('buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
